import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/BlankLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/app/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandProvider"] */ "/app/src/contexts/brandContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthProvider"] */ "/app/src/contexts/nextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/styles/AppReactToastify.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/NotFound.tsx");
